export const HOW_WORK_STARTS_LIST = [
  {
    title: 'Пробный урок',
    description:
      'Познакомитесь с&nbsp;преподавателем, проверите уровень языка, обсудите цели и&nbsp;продолжительность занятий',
  },
  {
    title: 'Личный роудмэп',
    description: 'Учебный план, составленный нашим методистом на&nbsp;основе вашей цели, профессии и&nbsp;интересах',
  },
  {
    title: 'Уроки в удобное время',
    description: '2&nbsp;раза в&nbsp;неделю, 80% урока&nbsp;&mdash; спикинг с&nbsp;практикой реальных рабочих ситуаций',
  },
  {
    title: 'Контроль прогресса',
    description: 'Результаты видны через 10&nbsp;занятий',
  },
];
